import {
    USERCATEGORY_LOADING,
    USERCATEGORY_SET,
    USERCATEGORY_ERROR,
    USERCATEGORY_ADD,
    USERCATEGORY_SHOW,
    USERCATEGORY_DELETE,
    USERCATEGORY_UPDATE,
    USERCATEGORY_RESET,
    USERCATEGORY_EDIT,
    USERCATEGORYPERMISSION_ADD,
} from './usercategoryActions'

const initialState = {
    loading: false,
    data: [],
    error: null,
    success: null,
    idEdit: null,
    idxShow: null,
}

const usercategoryReducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case USERCATEGORY_LOADING:
            return {
                ...state,
                loading: true,
            }
        case USERCATEGORY_UPDATE:
            return {
                ...state,
                loading: false,
                data: state.data.map(x => x.id === payload.id ? payload : x),
                success: 'Data has been updated successfully.'
            }
        case USERCATEGORY_SET:
            return {
                ...state,
                error: null,
                loading: false,
                data: payload
            }
        case USERCATEGORYPERMISSION_ADD:
            console.log(payload);
            return {
                ...state,
                error: null,
                loading: false,
                data: payload,
            }
        case USERCATEGORY_ADD:
            return {
                ...state,
                loading: false,
                error: null,
                data: [payload, ...state.data],
                success: 'New user category has been added successfully.'
            }
        case USERCATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }
        case USERCATEGORY_SHOW:
            return {
                ...state,
                idxShow: payload,
                success: null,
                error: null
            }
        case USERCATEGORY_RESET:
            return {
                ...state,
                error: null,
                success: null,
            }
        case USERCATEGORY_EDIT:
            return {
                ...state,
                error: null,
                success: null,
                idEdit: payload
            }
        case USERCATEGORY_DELETE:
            return {
                ...state,
                success: 'Data has been deleted successfully',
                error: null,
                data: state.data.filter(a => !payload.includes(a.id)),
                loading: false,
            }
        default:
            return state;
    }
}

export default usercategoryReducer